import { Address, DateAt } from '../../shared/interfaces/common.interface';
import { Guide } from '../guide.interface';

export const ORDER_STATUS = {
  // CANCELLED: 'cancelled',
  WITH_REFUNDS: 'with_refunds',
  PENDING_PAYMENT: 'payment',
  EXPIRED: 'expired',
  COMPLETED: 'completed',
  PENDING_APPROVAL: 'approval',
  CONV_STORE: 'convstore',
  PREAUTHORIZED: 'preauthorized',
  REJECTED: 'rejected',
  CANCELLED: 'cancelled',
}

export const PACKAGE_STATUS = {
  PENDING: 'pending',
  ROUTED: 'routed',
  DELIVERED: 'delivered',
  PACKING: 'packing',
};
export const ORDER_TYPE = {
  STANDARD: 'standard',
  ALL: 'all',
  LOCAL_PICKUP: 'local_pickup',
  MARKETPLACE: 'marketplace',
};

export interface Destination {
  name?: string;
  addressLine1?: string;
  addressLine2?: string;
  addressLine3?: string;
  crossStreet?: string;
  reference?: string;
  city?: string;
  state?: string;
  country?: string;
  primaryPhone?: string;
  secondaryPhone?: string;
  postalCode?: string;
  integrations?: any;
  shippingMethod?: any;
}

export interface Dimensions {
  weight?: number;
  height?: number;
  width?: number;
  length?: number;
}

export interface Item {
  muventaSKU?: string;
  vendorSKU?: string;
  name?: string;
  attributes?: string;
  pType?: string;
  slug?: string;
  vendor?: string;
  vendorBusinessName?: string;
  dimensions?: Dimensions;
  quantity?: number;
  vendorPrice?: number;
  muventaPrice?: number;
  taxCollected?: number;
  profit?: number;
  total?: number;
}

export interface Package {
  version?: number;
  createdAt?: DateAt;
  updatedAt?: DateAt;
  createdBy?: string;
  modifiedBy?: string;
  id?: string;
  vendor?: string;
  orderId?: string;
  deliveryMode?: string;
  carrier?: string;
  trackingNum?: string;
  trackingUrl?: string;
  documentUrl?: string;
  collectedAt?: string;
  willDeliverAt?: string;
  deliveredAt?: string;
  status?: string;
  from?: Address;
  to?: Address;
  customerName?: string;
  customerId?: string;
  weight?: number;
  deliveryCost?: number;
  itemCost?: number;
  taxCollected?: number;
  profit?: number;
  items?: Item[];
  notifyUpdates?: boolean;
}

export interface Payment {
  gateway?: string;
  url?: string;
  paid?: boolean;
  authorization?: string;
  operationId?: string;
  type?: string;
  card?: string;
  gatewayResponse?: string;
  payPalId?: string;
}

export interface Order {
  version?: number;
  type?: string;
  createdAt?: DateAt;
  updatedAt?: DateAt;
  paidAt?: DateAt;
  createdBy?: string;
  modifiedBy?: string;
  id?: string;
  customerId?: string;
  customerEmail?: string;
  customerName?: string;
  salesmanId?: string;
  placedBy?: string;
  referredBy?: string;
  referredName?: string;
  destination?: Destination;
  comments?: string;
  packages?: Package[];
  reservations?: any[];
  payment?: Payment[];
  vendors?: string;
  coupons?: string;
  currency?: string;
  itemSubtotal?: number;
  subtotal?: number;
  taxesCollected?: number;
  deliveryCost?: number;
  deliveryDiscount?: number;
  deliveryTotal?: number;
  txFee?: number;
  eMoney?: number;
  eWallet?: number;
  profit?: number;
  total?: number;
  orderStatus?: string;
  hasRefunds?: boolean;
  rewardsProcessed?: boolean;
  itemsProcessed?: boolean;
  activatesMembership?: boolean;
  deliveryDate?: string;

  // Internal
  convStore?: boolean;
  guide?: Guide;
  warehouseLocation?: any;
}
